"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterLabel = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var WrappedFilterLabel = /** @class */ (function (_super) {
    tslib_1.__extends(WrappedFilterLabel, _super);
    function WrappedFilterLabel(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hasEllipsis: false };
        _this.labelRef = react_1.createRef();
        return _this;
    }
    WrappedFilterLabel.prototype.componentDidMount = function () {
        this.checkEllipsis();
    };
    WrappedFilterLabel.prototype.componentDidUpdate = function () {
        this.checkEllipsis();
    };
    WrappedFilterLabel.prototype.getIsDate = function () {
        return this.props.isDate;
    };
    WrappedFilterLabel.prototype.isAllSelected = function () {
        return this.props.isAllSelected;
    };
    WrappedFilterLabel.prototype.checkEllipsis = function () {
        var _a = this.labelRef.current, offsetWidth = _a.offsetWidth, scrollWidth = _a.scrollWidth;
        // for some reason, IE11 returns offsetWidth = scrollWidth - 1 even when there is no ellipsis
        var hasEllipsis = offsetWidth < scrollWidth - 1;
        if (hasEllipsis !== this.state.hasEllipsis) {
            this.setState({ hasEllipsis: hasEllipsis });
        }
    };
    WrappedFilterLabel.prototype.renderSelectionLabel = function (content) {
        return react_1.default.createElement("span", { className: "count s-total-count" }, content);
    };
    WrappedFilterLabel.prototype.renderSelection = function () {
        if (!this.getIsDate() && !this.props.noData) {
            var _a = this.props, selectionSize = _a.selectionSize, intl = _a.intl;
            if (this.isAllSelected()) {
                return this.renderSelectionLabel(intl.formatMessage({ id: "gs.filterLabel.all" }));
            }
            if (selectionSize === 0) {
                return this.renderSelectionLabel(intl.formatMessage({ id: "gs.filterLabel.none" }));
            }
            if (this.state.hasEllipsis && selectionSize > 0) {
                return this.renderSelectionLabel("(" + selectionSize + ")");
            }
        }
        return false;
    };
    WrappedFilterLabel.prototype.renderTitle = function () {
        return [
            react_1.default.createElement("span", { className: "filter-label-title", key: "title", title: this.props.title }, this.props.title),
            this.isAllSelected() && !this.getIsDate() && !this.props.noData ? (react_1.default.createElement("span", { key: "title-colon" }, ": ")) : (false),
        ];
    };
    WrappedFilterLabel.prototype.renderSelectedElements = function () {
        if (!this.props.selection || this.isAllSelected()) {
            return false;
        }
        return [
            react_1.default.createElement("span", { key: "selection-colon" }, ": "),
            react_1.default.createElement("span", { className: "filter-label-selection", key: "selection" }, this.props.selection),
        ];
    };
    WrappedFilterLabel.prototype.render = function () {
        return (react_1.default.createElement("div", { role: "attribute-filter-label", className: "adi-attribute-filter-label s-attribute-filter-label" },
            react_1.default.createElement("span", { className: "label", ref: this.labelRef },
                this.renderTitle(),
                this.renderSelectedElements()),
            this.renderSelection()));
    };
    WrappedFilterLabel.defaultProps = {
        isAllSelected: false,
        isDate: false,
        selection: "",
        noData: false,
    };
    return WrappedFilterLabel;
}(react_1.default.PureComponent));
/**
 * @internal
 */
exports.FilterLabel = react_intl_1.injectIntl(WrappedFilterLabel);
//# sourceMappingURL=FilterLabel.js.map